export default __webpack_public_path__ + "static/media/cleaningmethods.fb16b956.pdf";